<div appTheme>
    <div class="main-container scrolling fixed-width-container"
        [ngClass]="{'external-terms-or-privacy': isExternalTermsOrPrivacy}">
        <div class="container col-sm-12">
            <h1>Privacy Policy</h1>
            <hr>
            <h4 class="privacy-header">Effective Date: January 1, 2016</h4>
            <h2 class="privacy-header">THE TORO COMPANY</h2>
            <h4>PRIVACY POLICY</h4>
            <div>
                <h4>Toro's Commitment to Your Privacy</h4>
                <p>The Toro Company respects your privacy. We provide this Privacy Policy so you know about our online
                    information practices and understand how we
                    treat the information we receive about you from your use of this website (the "Site") and any mobile
                    application of ours (each, an “App”)
                    (collectively, the “Service”). This Policy applies, in general, to all Internet sites and mobile
                    applications operated by or on behalf of The
                    Toro Company and our affiliates and business units worldwide (collectively, “Toro”).
                </p>
                <p>Please read this Privacy Policy. By using or visiting the Service, or downloading, registering or
                    using an App, you agree to the terms of this
                    Privacy Policy and our Terms and Conditions of Use (the “Terms”). Use of this Service is voluntary.
                    If you do not agree to the Privacy Policy
                    and the Terms, you must immediately cease such use.</p>
            </div>
            <div>
                <h4>The Personal Information Toro Collects</h4>
                <p>There are a few places where Toro gives you an opportunity to voluntarily provide Toro with your
                    personal information. This refers to information
                    that lets Toro know the specifics of who you are, and may include, without limitation, your first
                    and last name, mailing address, email address,
                    telephone number, credit card number, and other personally identifying information. When you engage
                    in certain activities on the Service, such
                    as ordering a product or service; filling out a form to request a demo, entering a contest or
                    sweepstakes; participating in third-party social
                    network service activities whether through the Service or third-party social network services;
                    filling out a survey; sending feedback or product
                    reviews; requesting owners and parts manuals; or registering your product online, Toro may ask you
                    to provide personal information. You choose
                    whether to engage in these activities. Depending upon the activity, some of the information Toro
                    asks you to provide is identified as mandatory
                    and some is voluntary. If you do not provide the mandatory data with respect to a particular
                    activity, you will not be able to engage in that
                    activity.</p>
                <p>In addition to the information you choose to provide, Toro may automatically collect other
                    information about you. Such information may include,
                    without limitation: the unique device identifier of your mobile device, mobile network information,
                    the model and serial number and telephone
                    number of your mobile device, your geographic location, information regarding your access to and use
                    of an App, the Site pages you visit and the
                    time of your visits, your operating system, browser type, the domain name of your internet service
                    provider, and your Internet Protocol (IP)
                    address. We may combine any of the information we collect from or about you and use it in the manner
                    described in this Privacy Policy. For
                    example, Toro may use your IP address, together with other personal information that you may provide
                    through the Site, such as your email
                    address, to communicate with you directly about products and services that Toro believes may be of
                    interest based on your activity on the Site
                    .</p>
            </div>
            <h5>Toro also may collect information about you from publicly available sources and may receive information
                through a third-party social networking
                service.</h5>
            <div>
                <h4>The Anonymous Information Toro Collects</h4>
                <p>Except as otherwise stated in this Policy, your IP address, cookies and other technologies (as more
                    particularly described below) are generally
                    used by Toro on an anonymous basis to, among other things, (1) help diagnose problems with Toro's
                    server, administer the Service, measure the
                    use of the Service, improve the content of the Service; (2) to identify visitors' domain names, the
                    type of web browsers used, the pages viewed,
                    the websites from which a visitor found this Service, the websites to which a visitor went after
                    leaving the Service; the search terms and
                    search engines used to find this Service; and (3) to gather other web analytics information relating
                    to visitors' use and navigation of the
                    Service.</p>
                <h5>Cookies and Other Technologies</h5>
                <p>We, along with third parties, use cookies, web beacons, analytics and other technologies in certain
                    areas. These technologies are used for
                    tracking, analytics, personalization and optimization of the Service.</p>
                <p><u>Cookies</u> are small text files that are stored on your browser. Cookies enable browsers to
                    "remember" information related to a specific
                    user, and also improve navigational reliability within a given site. The use of cookies allows Toro
                    to recognize you every time you visit, and
                    to personalize the Site to better suit your needs. If you are uncomfortable with storing cookies on
                    your browser, you may set your browser
                    specifically to reject cookies but you may not be able to use all the functionality of the Site.
                    Toro uses various types of cookies:</p>
                <p class="indent"><u>Strictly Necessary Cookies</u> are essential in order to enable you to move around
                    the Site and use its features. Without these
                    cookies, services you have asked for cannot be provided. They are deleted when you close the
                    browser.</p>
                <p class="indent"><u>Performance Cookies</u> collect information in an anonymous form about how visitors
                    use the Site. They allow Toro to recognize
                    and count the number of visitors and to see how visitors move around the Site when they are using
                    it.</p>
                <p class="indent"><u>Functionality Cookies</u> allow the website to remember choices you make (such as
                    your user name, language or the region you
                    are in) and provide enhanced, more personal features and to improve your experience on the Site.</p>
                <p class="indent"><u>Targeting cookies</u> or advertising cookies are used to collect information about
                    your browsing habits in order to enable Toro
                    and its affiliates to provide you with information about products and services that may be of
                    specifically of interest to you.</p>
                <h5><u>Web Beacons</u> are small strings of code (e.g., 1 x 1 pixel) that provide a method for
                    delivering a graphic image on a Web page or in an
                    email message for the purpose of transferring data. You can disable the ability of Web beacons to
                    capture information by blocking cookies.</h5>
                <h5><u>Persistent Device Identifiers</u> are unique strings that are associated with the mobile device
                    that you use to connect to an App. Persistent
                    device identifiers may be modified or disabled by sophisticated users.</h5>
                <h5>Third parties may collect personally identifiable information about an individual user’s online
                    activities over time and across different
                    Internet services when a user uses the Service.</h5>
                <h5>We use Remarketing with Google Analytics and DoubleClick’s remarketing pixels to advertise online.
                    We use and third-party vendors, including
                    Google, use cookies to serve our ads to you on sites across the Internet based on your past visits
                    to the Service.</h5>
                <h5>To opt-out of the Google Analytics browser add-on, please visit: <a
                        href="https://tools.google.com/dlpage/gaoptout/"
                        target="_blank">https://tools.google.com/dlpage/gaoptout/</a>
                    , <a href="http://www.google.com/policies/privacy/"
                        target="_blank">http://www.google.com/policies/privacy/</a> , <a
                        href="http://www.google.com/policies/privacy/partners/"
                        target="_blank">http://www.google.com/policies/privacy/partners/</a> and <a
                        href="http://www.google.com/analytics/terms/us.html "
                        target="_blank">http://www.google.com/analytics/terms/us.html </a>.</h5>
                <h5>To opt-out of Google’s use of cookies in connection with remarketing, please visit:
                    <a href="http://www.google.com/settings/ads/anonymous?hl=en&sig=ACi0TCitXI7MlNi0lAkOlTxr3hBoyIJWyzWQgcRIDEP1XgHp1s-gqp9WbEUidfXztBOLw6NtKtrgTDjVnkM38PBY-pg47JGKUgA1yqg7yMwaKQ8U8WpI69g"
                        target="_blank">http://www.google.com/settings/ads/anonymous?hl=en&sig=ACi0TCitXI7MlNi0lAkOlTxr3hBoyIJWyzWQgcRIDEP1XgHp1s-gqp9WbEUidfXztBOLw6NtKtrgTDjVnkM38PBY-pg47JGKUgA1yqg7yMwaKQ8U8WpI69g</a>
                </h5>
                <h5>To opt-out of DoubleClick’s or other third-party vendors’ use of cookies, please visit: <a
                        href="www.networkadvertising.org/choices/"
                        target="_blank">www.networkadvertising.org/choices/</a>
                </h5>
                <h5>Note that clearing cookies from your browser will remove the above opt-outs because they are stored
                    in cookies.</h5>
                <h5>Do Not Track. At this time we do not respond to “Do Not Track” signals sent from Web browsers or
                    other mechanisms that provide users the ability
                    to exercise choice regarding the collection of personally identifiable information about a user’s
                    online activities over time and across
                    third-party internet services.</h5>
            </div>
            <div>
                <h4>Consent</h4>
                <p>For EU users only: To comply with current legislation in the European Union, Toro asks for your
                    consent to set the cookies described above. When
                    you arrive on the Site, a banner informing you of the types of cookies we use will appear. By
                    clicking 'continue' you expressly consent to the
                    use of such cookies. Once your consent has been provided, this message will not appear again when
                    you revisit. If you do not click “continue,”
                    your continued use of the Site will indicate your implied consent. The banner will remain, and we
                    will set only the cookies for which implied
                    consent is sufficient. If you, or another user of your computer, wish to withdraw your consent at
                    any time, you can do so by altering your
                    browser settings or by selecting the opt-out options above.</p>
            </div>
            <div>
                <h4>The Way Toro Uses Personal Information</h4>
                <p>Toro may use your personal information for particular activities, including, without limitation, the
                    purposes for which you provided it; to
                    provide the Service to you, including any updates or notifications; to create or add to your user
                    profile or registered account; to process and
                    respond to your inquiries and comments; to send you information about your relationship or
                    transactions with us; to improve the Service or to
                    develop new products and services; to identify you as a user of the Service; to allow you to
                    participate in surveys; to contact you with
                    information, including personal information, that we believe will be of interest to you, done either
                    by us or a third-party source; for research
                    that we or a third party may perform regarding the Service; to create anonymous data, which we may
                    use for any purpose; to compile aggregate
                    data for internal and external business purposes; to analyze the Service; to allow us to personalize
                    and enhance your experience using the
                    Service; to send push notifications through the App; to send emails; to generate and review reports
                    and data about our user base and service
                    usage patterns, to analyze the accuracy, effectiveness, usability or popularity of the Service; to
                    prevent fraudulent transactions, monitor
                    against theft and otherwise protect our users and our business; to administer and troubleshoot the
                    Service; and as otherwise stated in this
                    Privacy Policy.</p>
                <h5>The Way Toro May Disclose Information</h5>
                <p>Toro may share this information with Toro's affiliates, distributors, dealers or other business
                    partners in connection with the Service. We may
                    share information about you that they need to perform their functions and in accordance with our
                    agreements with them. Toro's affiliates,
                    distributors, dealers or other business partners may use this information for marketing and
                    solicitation purposes as permitted by applicable
                    law. Toro must release your credit card information to credit card authorization service providers
                    and the credit card-issuing bank to confirm
                    and settle payment for products or services purchased on the Service and to facilitate returns or
                    refunds. Toro may share aggregated anonymous
                    information relating to visitors to and users of the Service with affiliated or unaffiliated third
                    parties.</p>
                <p>Toro may disclose personal information in any of the following circumstances: (1) in response to a
                    subpoena, search warrant, court order, or
                    other legal process or request, or as may otherwise be required by applicable law or regulation; (2)
                    to protect and defend Toro's rights or
                    property or those of its affiliates, distributors, dealers, business partners, or others; (3) to
                    enforce or apply the Terms or any applicable
                    end user license agreement; or (4) as Toro, in its sole discretion, believes is appropriate under
                    exigent circumstances in response to a
                    perceived threat to the personal safety or property of any person or organization.</p>
                <p>If Toro becomes involved in a merger, acquisition, sale of assets, joint venture, securities
                    offering, bankruptcy, reorganization, liquidation,
                    dissolution, or other transaction, or if the ownership of all or substantially all of our business
                    otherwise changes, Toro may share or transfer
                    your information to a third party or parties in connection therewith.</p>
            </div>
            <div>
                <h4>Processing of your Personal Information</h4>
                <p>This Service is currently hosted on servers located within the United States, but the locations of
                    Toro's servers may change from time-to-time.
                    Your personal information may be stored on servers located within the United States, or in another
                    country. In addition, Toro may transfer your
                    personal information to affiliates, distributors, dealers, business partners, or others located in
                    the United States or other countries in
                    accordance with, and for the purposes as described in, this Privacy Policy. In these circumstances,
                    Toro will ensure that your personal data is
                    adequately protected.
                </p>
            </div>
            <h5>BY SUBMITTING YOUR PERSONAL INFORMATION TO TORO, YOU ARE CONSENTING TO THE PROCESSING OF YOUR PERSONAL
                INFORMATION IN THE UNITED STATES OR IN ANY
                OTHER COUNTRY IN THE WORLD.</h5>
            <div>
                <h4>Retention of your Personal Information</h4>
                <p>Toro will not knowingly collect personal information about children under the age of 18. If you are
                    under the age of 18, please do not submit any
                    personal information through the Service. If you have reason to believe that we may have
                    accidentally received personal information from an
                    individual under age 18, please contact us immediately at legal@toro.com</p>
            </div>
            <div>
                <h4>Access & Correction of your Personal Information</h4>
                <p>Toro strives to maintain the accuracy and integrity of the personal information in its databases and
                    to keep that information up-to-date. Toro
                    provides ways for you to access your personal information as required by applicable law, so that you
                    can correct inaccuracies or update your
                    personal information. Toro reserves the right to charge a fee as permitted by applicable law. If you
                    would like to review or correct your
                    personal information, please contact Toro by email at <a
                        href="mailto:legal@toro.com">legal@toro.com</a> , or send a letter to: </p>
                <p>The Toro Company<br>
                    Attn: Legal Department<br>
                    8111 Lyndale Avenue South<br>
                    Bloomington, MN 55420-1196<br>
                </p>
                <p>All communications must be in the English language.</p>
                <p>Toro will respond to reasonable requests within the time limits established by applicable law or
                    within a reasonable time if no time limit is
                    established by applicable law. For your protection, Toro may ask you for additional information to
                    verify your identity. In most cases, Toro
                    will provide the access you request and correct or delete any inaccurate personal information you
                    discover.</p>
                <p>Requests to delete personal data are subject to any applicable legal and ethical reporting or
                    document retention obligations imposed on Toro.</p>
            </div>
            <div>
                <h4>Toro's Commitment to Security of Your Personal Information</h4>
                <p>Toro has implemented physical, managerial and technical procedures to try to protect the security of
                    data and information, including personal
                    information. Toro strives to maintain the reliability, accuracy, completeness, and current status of
                    personal information and to protect the
                    privacy and security of such. Unless applicable law provides otherwise, Toro does not guarantee
                    against any loss, misuse, unauthorized
                    disclosure, alteration or destruction of data or personal information. While Toro strives to protect
                    your personal information, Toro cannot
                    always guarantee the security of any information you transmit to or from the Service, and you
                    provide such information at your own risk. You
                    acknowledge that: (1) there are security and privacy limitations in computer systems and on the
                    Internet which are beyond Toro's control; and
                    (2) any such information and data, including personal information, may be viewed or tampered with by
                    a third party while such information or
                    data is being used, transmitted, processed, or stored.</p>
            </div>
            <div>
                <h4>Changes to Privacy Policy</h4>
                <p>Toro may change its Privacy Policy from time to time. This Privacy Policy was made effective on the
                    date indicated above. Toro encourages you to
                    review this Privacy Policy regularly in your use of the Service and especially before you provide
                    any information.</p>
            </div>
            <br /><br /><br />
            <p>© The Toro Company {{currentYear}} - All Rights Reserved</p>
        </div>
    </div>
</div>